import { supabase } from '../lib/supabase';

const BUCKET = 'project-documents';

export const projectDocumentService = {
  async getByProject(projectId) {
    const { data, error } = await supabase?.from('project_documents')?.select('*, uploaded_by_profile:user_profiles!project_documents_uploaded_by_fkey(id, full_name, first_name, last_name, email)')?.eq('project_id', projectId)?.order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async addDocument(projectId, { name, documentNote, documentSource }, userId) {
    const { data, error } = await supabase?.from('project_documents')?.insert({
        project_id: projectId,
        uploaded_by: userId,
        name,
        is_link: false,
        document_note: documentNote || null,
        document_source: documentSource || null,
      })?.select('*, uploaded_by_profile:user_profiles!project_documents_uploaded_by_fkey(id, full_name, first_name, last_name, email)')?.single();
    if (error) throw error;
    return data;
  },

  async updateDocument(docId, { name, documentNote, documentSource }) {
    const { data, error } = await supabase?.from('project_documents')?.update({
        name,
        document_note: documentNote || null,
        document_source: documentSource || null,
      })?.eq('id', docId)?.select('*, uploaded_by_profile:user_profiles!project_documents_uploaded_by_fkey(id, full_name, first_name, last_name, email)')?.single();
    if (error) throw error;
    return data;
  },

  async uploadFile(projectId, file, userId) {
    const timestamp = Date.now();
    const safeName = file?.name?.replace(/[^a-zA-Z0-9._-]/g, '_');
    const filePath = `${projectId}/${timestamp}-${safeName}`;

    const { error: uploadError } = await supabase?.storage?.from(BUCKET)?.upload(filePath, file, { cacheControl: '3600', upsert: false });
    if (uploadError) throw uploadError;

    const { data, error } = await supabase?.from('project_documents')?.insert({
        project_id: projectId,
        uploaded_by: userId,
        name: file?.name,
        file_path: filePath,
        file_size: file?.size,
        mime_type: file?.type,
        is_link: false,
      })?.select('*, uploaded_by_profile:user_profiles!project_documents_uploaded_by_fkey(id, full_name, first_name, last_name, email)')?.single();
    if (error) throw error;
    return data;
  },

  async addLink(projectId, name, linkUrl, userId) {
    const { data, error } = await supabase?.from('project_documents')?.insert({
        project_id: projectId,
        uploaded_by: userId,
        name,
        is_link: true,
        link_url: linkUrl,
      })?.select('*, uploaded_by_profile:user_profiles!project_documents_uploaded_by_fkey(id, full_name, first_name, last_name, email)')?.single();
    if (error) throw error;
    return data;
  },

  async getSignedUrl(filePath) {
    const { data, error } = await supabase?.storage?.from(BUCKET)?.createSignedUrl(filePath, 3600);
    if (error) throw error;
    return data?.signedUrl;
  },

  async delete(doc) {
    if (!doc?.is_link && doc?.file_path) {
      await supabase?.storage?.from(BUCKET)?.remove([doc?.file_path]);
    }
    const { error } = await supabase?.from('project_documents')?.delete()?.eq('id', doc?.id);
    if (error) throw error;
  },
};
